/**
 * Global FAQ Toggle Component
 * Simple and bulletproof Web Component for FAQ animations
 */

class FaqToggle extends HTMLElement {
  constructor() {
    super();
    this._toggle = this._toggle.bind(this);

    // Find the answer element
    this.answer = this.querySelector('[class*="answer"]');

    if (this.answer) {
      // Set initial height
      const isOpen = this.hasAttribute('open') ||
                     this.classList.contains('actif') ||
                     this.classList.contains('is-active');

      this.answer.style.height = isOpen ? `${this.answer.scrollHeight}px` : '0px';
      this.answer.style.opacity = isOpen ? '1' : '0';
    }
  }

  connectedCallback() {
    // Find clickable elements (summary, button, or question)
    const trigger = this.querySelector('summary, button, [class*="question"]');

    if (trigger) {
      trigger.addEventListener('click', this._toggle);
    }
  }

  disconnectedCallback() {
    const trigger = this.querySelector('summary, button, [class*="question"]');
    if (trigger) {
      trigger.removeEventListener('click', this._toggle);
    }
  }

  _toggle(e) {
    e.preventDefault();

    if (!this.answer) return;

    // Toggle active state
    this.classList.toggle('actif');
    const isActive = this.classList.contains('actif');

    // Update height with animation
    if (isActive) {
      // Opening
      this.answer.style.height = '0px';
      this.answer.style.opacity = '0';

      requestAnimationFrame(() => {
        this.answer.style.height = `${this.answer.scrollHeight}px`;
        this.answer.style.opacity = '1';
      });

      // Update attributes for accessibility
      const button = this.querySelector('button, summary');
      if (button) {
        button.setAttribute('aria-expanded', 'true');
      }

      const answerEl = this.answer.closest('[aria-hidden]');
      if (answerEl) {
        answerEl.setAttribute('aria-hidden', 'false');
      }

    } else {
      // Closing
      this.answer.style.height = `${this.answer.scrollHeight}px`;

      requestAnimationFrame(() => {
        this.answer.style.height = '0px';
        this.answer.style.opacity = '0';
      });

      // Update attributes for accessibility
      const button = this.querySelector('button, summary');
      if (button) {
        button.setAttribute('aria-expanded', 'false');
      }

      const answerEl = this.answer.closest('[aria-hidden]');
      if (answerEl) {
        answerEl.setAttribute('aria-hidden', 'true');
      }
    }
  }
}

// Register the custom element
customElements.define('faq-toggle', FaqToggle);
